import { ArrowRightGreyIcon, CalendarGreyIcon, TableGreyIcon, UserGreyIcon } from "../../../assets/icons";
import { OrderStatusType, orderStatusTypeToString } from "../../../models/base/OrderStatusType";
import { orderTypeToString } from "../../../models/base/OrderType";
import { OrderHistoryDTO } from "../../../models/order/order.response";
import { ToLocalDateTimeString } from "../../../utils/dateFormater";
import UserModalTrigger from "../../shared/user-modal/UserModalTrigger";


interface OrderHistoryCardDineInProps {
    order: OrderHistoryDTO;
    setSelectedOrderId: (orderId: string) => void;
}

const OrderHistoryCardDineIn: React.FC<OrderHistoryCardDineInProps> = ({ order, setSelectedOrderId }) => {

    return (
        <div className="order-history-div">
            <div className="order-history-left-div">
                <div className="order-history-header-div">
                    <div>#{order.id}</div>
                    <div className={`small-box-div ${order.currentStatus === OrderStatusType.Cancelled ? "red-bg" : "grey-bg"}`}>
                        <div>{orderStatusTypeToString(order.currentStatus)}</div>
                    </div>
                    <div className="small-box-div">
                        <div>{orderTypeToString(order.type)}</div>
                    </div>
                </div>
                <div className="div-block-92">
                    <div className="div-block-91">
                        <img src={TableGreyIcon} loading="lazy" alt="" className="icon-size-20" />
                        <div className="description-text">Sto: {order.tableNumber}</div>
                    </div>
                    <div className="div-block-91">
                        <img src={CalendarGreyIcon} loading="lazy" alt="" className="icon-size-20" />
                        <div className="description-text">{ToLocalDateTimeString(order.createdAt.toString())}</div>
                    </div>
                    <div className="div-block-91">
                        <img src={UserGreyIcon} loading="lazy" alt="" className="icon-size-20" />
                        <div className="description-text">
                            <UserModalTrigger
                                orderId={order.id}
                                id={order.userId}
                                name={order.fullName}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="order-history-right-div">
                <div className="div-block-93">
                    <div className="fs-1-5rem">{order.price} RSD</div>
                    <div className="description-text">{order.orderItemsCount} stavki</div>
                </div>
                <div onClick={() => setSelectedOrderId(order.id)}>
                    <img src={ArrowRightGreyIcon} loading="lazy" alt="" className="icon-size-20" />
                </div>
            </div>
        </div>
    );
};

export default OrderHistoryCardDineIn;